import { DIALOG_TYPES } from './dialog-types.model';

export class DeleteWarningModel{
  type: DIALOG_TYPES = DIALOG_TYPES.DELETE;
  headerText: string = 'Delete Record';
  subHeaderText: string = 'Record deletion will also delete the associated schedule from the workbook';
  errorText: string = 'Note: This is an irreversible action';
  subInfoText: string = 'Are you sure you want to delete the record?';
  buttonCancelText: string = 'Cancel';
  buttonConfirmText: string = 'Delete';
  selectedSchedule: any;
}
